import { StyleOptions } from '@primeuix/themes';

export default (dt: StyleOptions['dt']) => `
.dark .p-card {
  border: 1px solid ${dt('content.border.color')};
}
.p-card {
  border: 1px solid transparent;
}
`;
